import { LogoLibertyMutualHoriz, LogoSafecoHoriz, LogoCobrand } from '@lmig/lmds-react-logos';

export const LOGOS = {
  safeco: LogoSafecoHoriz,
  liberty: LogoLibertyMutualHoriz,
  cobrand: LogoCobrand,
};
